import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-3xl font-bold text-red-500 mb-4">404</h1>
        <h2 className="text-xl font-semibold text-gray-700 mb-2">Página no encontrada</h2>
        <p className="text-gray-600 mb-6">La página que estás buscando no existe o ha sido movida.</p>
        <Link 
          to="/dashboard" 
          className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded transition-colors duration-300 block text-center"
        >
          Volver al dashboard
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
